/**
 * Producto con el mejor precio por kilo del catálogo.
 *
 * Se calcula EN VIVO desde el precio y el peso reales de cada paca, no es
 * una lista escrita a mano: si mañana cambian los precios, la etiqueta se
 * mueve sola al producto que de verdad corresponda. Deliberadamente NO es
 * un "más vendido": ese dato no existe en el sistema y no se inventa.
 *
 * Solo compara papel vendido por paca, y por LISTA BLANCA, no descartando
 * categorías conocidas: las bolsas se cotizan por kilo y los papeles de
 * snacks por millar (su precio no es comparable contra un precio por paca),
 * y el catálogo también tiene plásticos, que aunque sí se venden por paca no
 * son lo mismo que el papel. Con una lista de exclusiones, cualquier
 * categoría nueva entraría sola a la comparación y la etiqueta podría acabar
 * afirmando algo falso; con lista blanca, en el peor caso no se muestra.
 */
const SOLD_BY_BALE = ['papel'];

export function bestPricePerKgId(products = []) {
    let bestId = null;
    let bestRatio = Infinity;

    for (const p of products) {
        if (!SOLD_BY_BALE.includes(p.category)) continue;
        if (!(p.price > 0) || !(p.package_weight_kg > 0)) continue;

        const ratio = p.price / p.package_weight_kg;
        if (ratio < bestRatio) {
            bestRatio = ratio;
            bestId = p.id;
        }
    }

    return bestId;
}
